import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M0 5.4C0 4.76348 0.252856 4.15303 0.702944 3.70294C1.15303 3.25286 1.76348 3 2.4 3H21.6C22.2365 3 22.847 3.25286 23.2971 3.70294C23.7471 4.15303 24 4.76348 24 5.4V19.8C24 20.4365 23.7471 21.047 23.2971 21.4971C22.847 21.9471 22.2365 22.2 21.6 22.2H2.4C1.76348 22.2 1.15303 21.9471 0.702944 21.4971C0.252856 21.047 0 20.4365 0 19.8V5.4ZM4.2228 5.4L12 12.2052L19.7772 5.4H4.224H4.2228ZM21.6 6.9948L12.7908 14.7036C12.572 14.8953 12.2909 15.001 12 15.001C11.7091 15.001 11.428 14.8953 11.2092 14.7036L2.4 6.9948V19.8H21.6V6.9948Z' />
        </SvgIcon>
    );
});
